/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import arbitrationCourtDocuments from '../../../constants/arbitrationCourtDocuments';
import Button from '../../ReusableElements/Buttons/Button/Button';
import CallOrderForm from '../../CallOrderForm/CallOrderForm';
import './ArbitrationCourt.scss';

export default function ArbitrationCourt() {
  const { t } = useTranslation(['service_pages', 'buttons']);

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    });
  }, []);

  return (
    <section className="ArbitrationCourt">
      <div className="wrapper">
        <div className="arbitration-court-content">
          <div className="arbitration-court-content-top-row">
            <a
              className="previous-page-link"
              href="/"
            >
              {t('previous_page_title')}
            </a>
            <div className="arbitration-court-content-top-row__right-side">
              <h1 className="heading-one">
                {t('heading')}
              </h1>
              <p className="description">
                {t('description.arbitration_court')}
              </p>
            </div>
          </div>
          <div className="arbitration-court-document-list">
            {
              arbitrationCourtDocuments.map((arbitrationCourtDocument) => (
                <div
                  key={uuidv4()}
                  className="arbitration-court-document-list__item"
                >
                  <p className="arbitration-court-document-list__title">
                    {t(`arbitration_court_documents.${arbitrationCourtDocument.titleKey}`)}
                  </p>
                  <div className="buttons">
                    <Button
                      priority="primary"
                      link="#"
                      download
                    >
                      {t('buttons:download_the_form')}
                    </Button>
                    <Button
                      priority="secondary"
                      link="#"
                      target="_blank"
                    >
                      {t('buttons:view_the_sample')}
                    </Button>
                  </div>
                </div>
              ))
            }
          </div>
          <h1 className="heading-one heading-one_form">
            {t('call_order_form_heading')}
          </h1>
          <p className="description">
            {t('call_order_form_description')}
          </p>
          <CallOrderForm />
        </div>
      </div>
    </section>
  );
}
